/**
 * Created by piotr@revisual.io on 29/12/2025.
 */

const initialState = {
  dashboardStatsCollection: [],

  fetchDashboardStats: false,
  fetchDashboardStatsSuccess: false,
  fetchDashboardStatsError: null,

  eventsStatsCollection: {},
  fetchEventsStats: null,
  fetchEventsStatsSuccess: false,
  fetchEventsStatsError: null,

  planUsageStatsCollection: [],
  fetchPlanUsageStats: false,
  fetchPlanUsageStatsSuccess: false,
  fetchPlanUsageStatsError: null,

  eventsTimeSeriesCollection: [],
  fetchEventsTimeSeries: false,
  fetchEventsTimeSeriesSuccess: false,
  fetchEventsTimeSeriesError: null,

  eventSeriesCollection: [],
  fetchEventSeries: false,
  fetchEventSeriesSuccess: false,
  fetchEventSeriesError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "DASHBOARD_STATS_FETCH":
      return {
        ...state,
        dashboardStatsCollection: [],
        fetchDashboardStats: true,
        fetchDashboardStatsSuccess: false,
        fetchDashboardStatsError: null,
      };

    case "DASHBOARD_STATS_FETCH_FULFILLED":
      return {
        ...state,
        dashboardStatsCollection: action.payload.stats,
        fetchDashboardStats: false,
        fetchDashboardStatsSuccess: true,
        fetchDashboardStatsError: null,
      };

    case "DASHBOARD_STATS_FETCH_REJECTED":
      return {
        ...state,
        fetchDashboardStats: false,
        fetchDashboardStatsError: action.payload,
      };

    case "EVENTS_STATS_FETCH":
      return {
        ...state,
        fetchEventsStats: true,
        fetchEventsStatsSuccess: false,
        fetchEventsStatsError: null,
      };

    case "EVENTS_STATS_FETCH_FULFILLED":
      return {
        ...state,
        eventsCollection: {
          items: action.payload.events,
          pagination: action.payload.pagination,
        },
        fetchEventsStats: false,
        fetchEventsStatsSuccess: true,
        fetchEventsStatsError: null,
      };

    case "EVENTS_STATS_FETCH_REJECTED":
      return {
        ...state,
        fetchEventsStats: false,
        fetchEventsStatsError: action.payload,
      };

    case "EVENTS_TIME_SERIES_FETCH":
      return {
        ...state,
        fetchEventsTimeSeries: true,
        fetchEventsTimeSeriesSuccess: false,
        fetchEventsTimeSeriesError: null,
      };

    case "EVENTS_TIME_SERIES_FETCH_FULFILLED":
      return {
        ...state,
        eventsTimeSeriesCollection: action.payload.series,
        eventsTimeSeriesResolution: action.payload.resolution,
        eventsTimeSeriesResolutionLocked: action.payload.resolution_locked,
        fetchEventsTimeSeries: false,
        fetchEventsTimeSeriesSuccess: true,
        fetchEventsTimeSeriesError: null,
      };

    case "EVENTS_TIME_SERIES_FETCH_REJECTED":
      return {
        ...state,
        fetchEventsTimeSeries: false,
        fetchEventsTimeSeriesError: action.payload,
      };

    case "EVENT_SERIES_FETCH":
      return {
        ...state,
        fetchEventSeries: true,
        fetchEventSeriesSuccess: false,
        fetchEventSeriesError: null,
      };

    case "EVENT_SERIES_FETCH_FULFILLED":
      return {
        ...state,
        eventSeriesCollection: action.payload.series,
        fetchEventSeries: false,
        fetchEventSeriesSuccess: true,
        fetchEventSeriesError: null,
      };

    case "EVENT_SERIES_FETCH_REJECTED":
      return {
        ...state,
        fetchEventSeries: false,
        fetchEventSeriesError: action.payload,
      };
      1;

    case "PLAN_USAGE_STATS_FETCH":
      return {
        ...state,
        planUsageStatsCollection: [],
        fetchPlanUsageStats: true,
        fetchPlanUsageStatsSuccess: false,
        fetchPlanUsageStatsError: null,
      };

    case "PLAN_USAGE_STATS_FETCH_FULFILLED":
      return {
        ...state,
        planUsageStatsCollection: action.payload.widget_views || [],
        fetchPlanUsageStats: false,
        fetchPlanUsageStatsSuccess: true,
        fetchPlanUsageStatsError: null,
      };

    case "PLAN_USAGE_STATS_FETCH_REJECTED":
      return {
        ...state,
        fetchPlanUsageStats: false,
        fetchPlanUsageStatsSuccess: false,
        fetchPlanUsageStatsError: action.payload,
      };

    case "USER_AUTOLOGIN_FULFILLED":
    case "USER_AUTOLOGOUT":
    case "USER_SWITCH_ORG_FULFILLED":
      return {
        ...initialState,
      };

    default:
      return state;
  }

  return state;
}
